// COC7e 标准技能数据（前端版）
export interface SkillDef {
  key: string;
  name: string;
  baseValue: number;
  category: string;
  isSpecialization: boolean;
  specializations?: string[];
}

export const COC7E_SKILLS: SkillDef[] = [
  { key: 'accounting', name: '会计', baseValue: 5, category: 'general', isSpecialization: false },
  { key: 'animal_handling', name: '动物驯养', baseValue: 5, category: 'general', isSpecialization: false },
  { key: 'anthropology', name: '人类学', baseValue: 1, category: 'knowledge', isSpecialization: false },
  { key: 'appraise', name: '估价', baseValue: 5, category: 'general', isSpecialization: false },
  { key: 'archaeology', name: '考古学', baseValue: 1, category: 'knowledge', isSpecialization: false },
  { key: 'art_craft', name: '艺术与手艺', baseValue: 5, category: 'art', isSpecialization: true, specializations: ['写作', '表演', '摄影', '伪造', '美术', '音乐', '舞蹈', '烹饪', '设计图纸'] },
  { key: 'charm', name: '取悦', baseValue: 15, category: 'communication', isSpecialization: false },
  { key: 'climb', name: '攀爬', baseValue: 20, category: 'survival', isSpecialization: false },
  { key: 'computer_use', name: '计算机使用', baseValue: 5, category: 'general', isSpecialization: false },
  { key: 'credit_rating', name: '信用评级', baseValue: 0, category: 'general', isSpecialization: false },
  { key: 'cthulhu_mythos', name: '克苏鲁神话', baseValue: 0, category: 'magic', isSpecialization: false },
  { key: 'disguise', name: '乔装', baseValue: 5, category: 'general', isSpecialization: false },
  { key: 'dodge', name: '闪避', baseValue: 0, category: 'combat', isSpecialization: false },
  { key: 'drive_auto', name: '汽车驾驶', baseValue: 20, category: 'general', isSpecialization: false },
  { key: 'elec_repair', name: '电气维修', baseValue: 10, category: 'general', isSpecialization: false },
  { key: 'electronics', name: '电子学', baseValue: 1, category: 'general', isSpecialization: false },
  { key: 'fast_talk', name: '话术', baseValue: 5, category: 'communication', isSpecialization: false },
  { key: 'fighting', name: '格斗', baseValue: 0, category: 'combat', isSpecialization: true, specializations: ['斗殴', '斧', '链锯', '连枷', '绞索', '矛', '剑', '鞭'] },
  { key: 'firearms', name: '射击', baseValue: 0, category: 'combat', isSpecialization: true, specializations: ['弓', '手枪', '步枪/霰弹枪', '冲锋枪', '重武器', '火焰喷射器', '机枪'] },
  { key: 'first_aid', name: '急救', baseValue: 30, category: 'general', isSpecialization: false },
  { key: 'history', name: '历史', baseValue: 5, category: 'knowledge', isSpecialization: false },
  { key: 'intimidate', name: '恐吓', baseValue: 15, category: 'communication', isSpecialization: false },
  { key: 'jump', name: '跳跃', baseValue: 20, category: 'survival', isSpecialization: false },
  { key: 'language_other', name: '其他语言', baseValue: 1, category: 'language', isSpecialization: true },
  { key: 'language_own', name: '母语', baseValue: 0, category: 'language', isSpecialization: false },
  { key: 'law', name: '法律', baseValue: 5, category: 'knowledge', isSpecialization: false },
  { key: 'library_use', name: '图书馆使用', baseValue: 20, category: 'investigation', isSpecialization: false },
  { key: 'listen', name: '聆听', baseValue: 20, category: 'investigation', isSpecialization: false },
  { key: 'locksmith', name: '锁匠', baseValue: 1, category: 'general', isSpecialization: false },
  { key: 'mech_repair', name: '机械维修', baseValue: 10, category: 'general', isSpecialization: false },
  { key: 'medicine', name: '医学', baseValue: 1, category: 'knowledge', isSpecialization: false },
  { key: 'natural_world', name: '博物学', baseValue: 10, category: 'knowledge', isSpecialization: false },
  { key: 'navigate', name: '导航', baseValue: 10, category: 'survival', isSpecialization: false },
  { key: 'occult', name: '神秘学', baseValue: 5, category: 'knowledge', isSpecialization: false },
  { key: 'heavy_machinery', name: '操作重型机械', baseValue: 1, category: 'general', isSpecialization: false },
  { key: 'persuade', name: '说服', baseValue: 10, category: 'communication', isSpecialization: false },
  { key: 'pilot', name: '驾驶', baseValue: 1, category: 'general', isSpecialization: true, specializations: ['飞机', '船'] },
  { key: 'psychoanalysis', name: '精神分析', baseValue: 1, category: 'knowledge', isSpecialization: false },
  { key: 'psychology', name: '心理学', baseValue: 10, category: 'communication', isSpecialization: false },
  { key: 'ride', name: '骑术', baseValue: 5, category: 'general', isSpecialization: false },
  { key: 'science', name: '科学', baseValue: 1, category: 'science', isSpecialization: true, specializations: ['天文学', '生物学', '植物学', '化学', '密码学', '工程学', '司法科学', '地质学', '数学', '气象学', '药学', '物理学', '动物学'] },
  { key: 'sleight_of_hand', name: '妙手', baseValue: 10, category: 'general', isSpecialization: false },
  { key: 'spot_hidden', name: '侦查', baseValue: 25, category: 'investigation', isSpecialization: false },
  { key: 'stealth', name: '潜行', baseValue: 20, category: 'survival', isSpecialization: false },
  { key: 'survival', name: '生存', baseValue: 10, category: 'survival', isSpecialization: true, specializations: ['沙漠', '极地', '海洋', '森林'] },
  { key: 'swim', name: '游泳', baseValue: 20, category: 'survival', isSpecialization: false },
  { key: 'throw', name: '投掷', baseValue: 20, category: 'combat', isSpecialization: false },
  { key: 'track', name: '追踪', baseValue: 10, category: 'survival', isSpecialization: false },
  { key: 'diving', name: '潜水', baseValue: 1, category: 'survival', isSpecialization: false },
  { key: 'demolitions', name: '爆破', baseValue: 1, category: 'general', isSpecialization: false },
];

export const SKILL_CATEGORIES: Record<string, string> = {
  combat: '战斗', communication: '社交', investigation: '调查',
  knowledge: '学识', survival: '生存', magic: '神秘',
  language: '语言', science: '科学', art: '艺术', general: '通用',
};

export function getDefaultSkills(): Record<string, number> {
  const skills: Record<string, number> = {};
  for (const s of COC7E_SKILLS) {
    skills[s.key] = s.baseValue;
  }
  return skills;
}

export function resolveDynamicBases(attrs: { dex: number; edu: number }): Record<string, number> {
  return {
    dodge: Math.floor(attrs.dex / 2),
    language_own: attrs.edu,
  };
}

export interface OccupationDisplay {
  key: string;
  name: string;
  nameEn?: string;
  category: string;
  skillPointFormula: string;
  creditRatingMin: number;
  creditRatingMax: number;
  coreSkills: string[];
  coreSkillDisplay?: string[];
  electiveDescription?: string;
  electivePool?: string[];
  electiveCount?: number;
}

export const COC7E_OCCUPATIONS: OccupationDisplay[] = [

// 会计师
  {
    key: 'accountant',
    name: '会计师',
    category: 'general',
    skillPointFormula: 'edu*4',
    creditRatingMin: 30,
    creditRatingMax: 70,
    coreSkills: ['accounting','law','library_use','listen','persuade','spot_hidden'],
    coreSkillDisplay: ['会计','法律','图书馆使用','聆听','说服','侦查','任意其他两项个人或时代特长'],
    electiveDescription: '任意其他两项个人或时代特长',
    electiveCount: 2,
  },
  // 杂技演员
  {
    key: 'acrobat',
    name: '杂技演员',
    category: 'artistic',
    skillPointFormula: 'edu*2+dex*2',
    creditRatingMin: 9,
    creditRatingMax: 20,
    coreSkills: ['climb','dodge','jump','throw','spot_hidden','swim'],
    coreSkillDisplay: ['攀爬','闪避','跳跃','投掷','侦查','游泳','任意两项其他个人或时代特长'],
    electiveDescription: '任意两项其他个人或时代特长',
    electiveCount: 2,
  },
  // 演员-戏剧
  {
    key: 'actor_stage',
    name: '演员（戏剧）',
    category: 'artistic',
    skillPointFormula: 'edu*2+app*2',
    creditRatingMin: 9,
    creditRatingMax: 40,
    coreSkills: ['art_craft:表演','disguise','fighting:斗殴','history','charm','fast_talk','intimidate','persuade','psychology'],
    coreSkillDisplay: ['艺术（表演）','乔装','格斗','历史','两项社交技能（魅惑、话术、恐吓、说服）','心理学','任意一项其他个人或时代特长'],
    electiveDescription: '两项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 2,
  },
  // 演员-电影
  {
    key: 'actor_film',
    name: '演员（电影）',
    category: 'artistic',
    skillPointFormula: 'edu*2+app*2',
    creditRatingMin: 20,
    creditRatingMax: 90,
    coreSkills: ['art_craft:表演','disguise','drive_auto','charm','fast_talk','intimidate','persuade','psychology'],
    coreSkillDisplay: ['艺术（表演）','乔装','汽车驾驶','两项社交技能（魅惑、话术、恐吓、说服）','心理学','任意两项其他个人或时代特长（如骑术或格斗）'],
    electiveDescription: '两项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 2,
  },
  // 事务所侦探
  {
    key: 'agency_detective',
    name: '事务所侦探',
    category: 'military',
    skillPointFormula: 'edu*2+max(str,dex)*2',
    creditRatingMin: 20,
    creditRatingMax: 45,
    coreSkills: ['charm','fast_talk','intimidate','persuade','fighting:斗殴','firearms:手枪','law','library_use','psychology','stealth','track'],
    coreSkillDisplay: ['一项社交技能（魅惑、话术、恐吓、说服）','格斗（斗殴）','射击','法律','图书馆使用','心理学','潜行','追踪'],
    electiveDescription: '一项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 1,
  },
  // 精神病医生（古典）
  {
    key: 'alienist',
    name: '精神病医生（古典）',
    category: 'medical',
    skillPointFormula: 'edu*4',
    creditRatingMin: 10,
    creditRatingMax: 60,
    coreSkills: ['law','listen','medicine','language_other:任一','psychoanalysis','psychology','science:生物学','science:化学'],
    coreSkillDisplay: ['法律','聆听','医学','外语','精神分析','心理学','科学（生物学，化学）'],
    electiveCount: 0,
  },
  // 动物训练师
  {
    key: 'animal_trainer',
    name: '动物训练师',
    category: 'outdoor',
    skillPointFormula: 'edu*2+max(app,pow)*2',
    creditRatingMin: 10,
    creditRatingMax: 40,
    coreSkills: ['jump','listen','natural_world','animal_handling','science:动物学','stealth','track'],
    coreSkillDisplay: ['跳跃','聆听','博物学','动物驯养','科学（动物学）','潜行','追踪','任意一项其他个人或时代特长'],
    electiveDescription: '任意一项其他个人或时代特长',
    electiveCount: 1,
  },
  // 文物学家（原作向）
  {
    key: 'antiquarian_lh',
    name: '文物学家（原作向）',
    category: 'academic',
    skillPointFormula: 'edu*4',
    creditRatingMin: 30,
    creditRatingMax: 70,
    coreSkills: ['appraise','art_craft:任一','history','library_use','language_other:任一','charm','fast_talk','intimidate','persuade','spot_hidden'],
    coreSkillDisplay: ['估价','艺术/工艺（任一）','历史','图书馆使用','外语','一项社交技能（魅惑、话术、恐吓、说服）','侦查','任意一项其他个人或时代特长'],
    electiveDescription: '一项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 1,
  },
  // 古董商
  {
    key: 'antique_dealer',
    name: '古董商',
    category: 'general',
    skillPointFormula: 'edu*4',
    creditRatingMin: 30,
    creditRatingMax: 50,
    coreSkills: ['accounting','appraise','drive_auto','charm','fast_talk','intimidate','persuade','history','library_use','navigate'],
    coreSkillDisplay: ['会计','估价','汽车驾驶','两项社交技能（魅惑、话术、恐吓、说服）','历史','图书馆使用','导航'],
    electiveDescription: '两项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 2,
  },
  // 考古学家（原作向）
  {
    key: 'archaeologist',
    name: '考古学家（原作向）',
    category: 'academic',
    skillPointFormula: 'edu*4',
    creditRatingMin: 10,
    creditRatingMax: 40,
    coreSkills: ['appraise','archaeology','history','language_other:任一','library_use','spot_hidden','mech_repair','navigate'],
    coreSkillDisplay: ['估价','考古学','历史','外语','图书馆使用','侦查','机械维修','导航或科学（任一：如化学、物理、地理等）'],
    electiveDescription: '导航或科学（任一：如化学、物理、地理等）',
    electiveCount: 1,
  },
  // 建筑师
  {
    key: 'architect',
    name: '建筑师',
    category: 'academic',
    skillPointFormula: 'edu*4',
    creditRatingMin: 30,
    creditRatingMax: 70,
    coreSkills: ['accounting','art_craft:技术制图','law','language_own','computer_use','library_use','persuade','psychology','science:数学'],
    coreSkillDisplay: ['会计','工艺（技术制图）','法律','母语','计算机使用或图书馆使用','说服','心理学','科学（数学）'],
    electiveDescription: '计算机使用或图书馆使用',
    electiveCount: 1,
  },
  // 艺术家
  {
    key: 'artist',
    name: '艺术家',
    category: 'artistic',
    skillPointFormula: 'edu*2+max(dex,pow)*2',
    creditRatingMin: 9,
    creditRatingMax: 50,
    coreSkills: ['art_craft:任一','history','natural_world','charm','fast_talk','intimidate','persuade','language_other:任一','psychology','spot_hidden'],
    coreSkillDisplay: ['艺术/工艺（任一）','历史或博物学','一项社交技能（魅惑、话术、恐吓、说服）','外语','心理学','侦查','任意两项其他个人或时代特长'],
    electiveDescription: '一项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 1,
  },
  // 精神病院看护
  {
    key: 'asylum_attendant',
    name: '精神病院看护',
    category: 'medical',
    skillPointFormula: 'edu*2+max(str,dex)*2',
    creditRatingMin: 8,
    creditRatingMax: 20,
    coreSkills: ['dodge','fighting:斗殴','first_aid','charm','fast_talk','intimidate','persuade','listen','psychology','stealth'],
    coreSkillDisplay: ['闪避','格斗（斗殴）','急救','两项社交技能（魅惑、话术、恐吓、说服）','聆听','心理学','潜行'],
    electiveDescription: '两项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 2,
  },
  // 运动员
  {
    key: 'athlete',
    name: '运动员',
    category: 'outdoor',
    skillPointFormula: 'edu*2+max(dex,str)*2',
    creditRatingMin: 9,
    creditRatingMax: 70,
    coreSkills: ['climb','jump','fighting:斗殴','ride','charm','fast_talk','intimidate','persuade','swim','throw'],
    coreSkillDisplay: ['攀爬','跳跃','格斗（斗殴）','骑术','一项社交技能（魅惑、话术、恐吓、说服）','游泳','投掷','任意一项其他个人或时代特长'],
    electiveDescription: '一项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 1,
  },
  // 酒保
  {
    key: 'bartender',
    name: '酒保',
    category: 'service',
    skillPointFormula: 'edu*2+app*2',
    creditRatingMin: 8,
    creditRatingMax: 25,
    coreSkills: ['accounting','charm','fast_talk','intimidate','persuade','fighting:斗殴','listen','psychology','spot_hidden'],
    coreSkillDisplay: ['会计','两项社交技能（魅惑、话术、恐吓、说服）','格斗（斗殴）','聆听','心理学','侦查','任意一项其他个人或时代特长'],
    electiveDescription: '两项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 2,
  },
  // 猎人
  {
    key: 'hunter',
    name: '猎人',
    category: 'outdoor',
    skillPointFormula: 'edu*2+max(dex,str)*2',
    creditRatingMin: 20,
    creditRatingMax: 50,
    coreSkills: ['firearms:步枪/霰弹枪','listen','spot_hidden','natural_world','navigate','language_other:任一','survival:任一','science:生物学','stealth','track'],
    coreSkillDisplay: ['射击','聆听或侦查','博物学','导航','外语或生存（任一）','科学（生物学或植物学）','潜行','追踪'],
    electiveDescription: '聆听或侦查、外语或生存（任一）',
    electiveCount: 2,
  },
  // 作家（原作向）
  {
    key: 'author',
    name: '作家（原作向）',
    category: 'artistic',
    skillPointFormula: 'edu*4',
    creditRatingMin: 9,
    creditRatingMax: 30,
    coreSkills: ['art_craft:文学','history','library_use','natural_world','occult','language_other:任一','language_own','psychology'],
    coreSkillDisplay: ['艺术（文学）','历史','图书馆使用','博物学','神秘学','外语','母语','心理学'],
    electiveCount: 0,
  },
  // 书商
  {
    key: 'bookseller',
    name: '书商',
    category: 'general',
    skillPointFormula: 'edu*4',
    creditRatingMin: 20,
    creditRatingMax: 40,
    coreSkills: ['accounting','appraise','drive_auto','history','library_use','language_own','language_other:任一','charm','fast_talk','intimidate','persuade'],
    coreSkillDisplay: ['会计','估价','汽车驾驶','历史','图书馆使用','母语','外语','一项社交技能（魅惑、话术、恐吓、说服）'],
    electiveDescription: '一项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 1,
  },
  // 赏金猎人
  {
    key: 'bounty_hunter',
    name: '赏金猎人',
    category: 'criminal',
    skillPointFormula: 'edu*2+max(dex,str)*2',
    creditRatingMin: 9,
    creditRatingMax: 30,
    coreSkills: ['drive_auto','elec_repair','fighting:任一','firearms:任一','charm','fast_talk','intimidate','persuade','law','psychology','track','stealth'],
    coreSkillDisplay: ['汽车驾驶','电子学或电气维修','格斗或射击','一项社交技能（魅惑、话术、恐吓、说服）','法律','心理学','追踪','潜行'],
    electiveDescription: '格斗或射击、电子学或电气维修',
    electiveCount: 2,
  },
  // 管家/男仆/女仆
  {
    key: 'butler',
    name: '管家、男仆、女仆',
    category: 'service',
    skillPointFormula: 'edu*4',
    creditRatingMin: 9,
    creditRatingMax: 40,
    coreSkills: ['accounting','appraise','art_craft:任一','first_aid','listen','psychology','spot_hidden'],
    coreSkillDisplay: ['会计或估价','艺术/工艺（任一：如烹饪、裁缝、理发）','急救','聆听','心理学','侦查','任意两项其他个人或时代特长'],
    electiveDescription: '艺术/工艺（任一：如烹饪、裁缝、理发）',
    electiveCount: 1,
  },
  // 神职人员
  {
    key: 'clergy',
    name: '神职人员',
    category: 'general',
    skillPointFormula: 'edu*4',
    creditRatingMin: 9,
    creditRatingMax: 60,
    coreSkills: ['accounting','history','library_use','listen','language_other:任一','charm','fast_talk','intimidate','persuade','psychology'],
    coreSkillDisplay: ['会计','历史','图书馆使用','聆听','外语','一项社交技能（魅惑、话术、恐吓、说服）','心理学','任意一项其他技能'],
    electiveDescription: '一项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 1,
  },
  // 拳击手、摔跤手
  {
    key: 'boxer_wrestler',
    name: '拳击手、摔跤手',
    category: 'military',
    skillPointFormula: 'edu*2+str*2',
    creditRatingMin: 9,
    creditRatingMax: 60,
    coreSkills: ['dodge','fighting:斗殴','intimidate','jump','psychology','spot_hidden'],
    coreSkillDisplay: ['闪避','格斗（斗殴）','恐吓','跳跃','心理学','侦查','任意两项其他个人或时代特长'],
    electiveDescription: '任意两项其他个人或时代特长',
    electiveCount: 2,
  },
  // 计算机程序员、工程师
  {
    key: 'programmer',
    name: '计算机程序员、工程师',
    category: 'general',
    skillPointFormula: 'edu*4',
    creditRatingMin: 10,
    creditRatingMax: 70,
    coreSkills: ['computer_use','elec_repair','electronics','library_use','science:数学','spot_hidden'],
    coreSkillDisplay: ['计算机使用','电气维修','电子学','图书馆使用','科学（数学）','侦查','任意两项其他个人或时代特长'],
    electiveDescription: '任意两项其他个人或时代特长',
    electiveCount: 2,
  },
  // 黑客
  {
    key: 'hacker',
    name: '黑客',
    category: 'criminal',
    skillPointFormula: 'edu*4',
    creditRatingMin: 10,
    creditRatingMax: 70,
    coreSkills: ['computer_use','elec_repair','electronics','library_use','spot_hidden','charm','fast_talk','intimidate','persuade'],
    coreSkillDisplay: ['计算机使用','电气维修','电子学','图书馆使用','侦查','一项社交技能（魅惑、话术、恐吓、说服）','任意两项其他技能'],
    electiveDescription: '一项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 1,
  },
  // 牛仔
  {
    key: 'cowboy',
    name: '牛仔',
    category: 'outdoor',
    skillPointFormula: 'edu*2+max(dex,str)*2',
    creditRatingMin: 9,
    creditRatingMax: 20,
    coreSkills: ['dodge','fighting:任一','firearms:任一','first_aid','natural_world','jump','ride','survival:任一','throw','track'],
    coreSkillDisplay: ['闪避','格斗或射击','急救或博物学','跳跃','骑术','生存（任一）','投掷','追踪'],
    electiveDescription: '格斗或射击、急救或博物学',
    electiveCount: 2,
  },
  // 工匠
  {
    key: 'craftsman',
    name: '工匠',
    category: 'general',
    skillPointFormula: 'edu*4',
    creditRatingMin: 10,
    creditRatingMax: 40,
    coreSkills: ['accounting','art_craft:任二','mech_repair','natural_world','spot_hidden'],
    coreSkillDisplay: ['会计','艺术/工艺（任二）','机械维修','博物学','侦查','任意两项其他个人或时代特长'],
    electiveDescription: '艺术/工艺（任二）',
    electiveCount: 2,
  },
  // 罪犯分类
  {
    key: 'assassin',
    name: '刺客',
    category: 'criminal',
    skillPointFormula: 'edu*2+max(dex,str)*2',
    creditRatingMin: 30,
    creditRatingMax: 60,
    coreSkills: ['disguise','elec_repair','fighting:任一','firearms:任一','locksmith','mech_repair','stealth','psychology'],
    coreSkillDisplay: ['乔装','电气维修','格斗','射击','锁匠','机械维修','潜行','心理学'],
    electiveCount: 0,
  },
  {
    key: 'bank_robber',
    name: '银行劫匪',
    category: 'criminal',
    skillPointFormula: 'edu*2+max(str,dex)*2',
    creditRatingMin: 5,
    creditRatingMax: 75,
    coreSkills: ['drive_auto','elec_repair','mech_repair','fighting:任一','firearms:任一','intimidate','locksmith','heavy_machinery'],
    coreSkillDisplay: ['汽车驾驶','电气维修或机械维修','格斗','射击','恐吓','锁匠','操作重型机械','任意一项其他个人或时代特长'],
    electiveDescription: '电气维修或机械维修',
    electiveCount: 1,
  },
  {
    key: 'bruiser',
    name: '打手、暴徒',
    category: 'criminal',
    skillPointFormula: 'edu*2+str*2',
    creditRatingMin: 5,
    creditRatingMax: 30,
    coreSkills: ['drive_auto','fighting:任一','firearms:任一','charm','fast_talk','intimidate','persuade','psychology','stealth','spot_hidden'],
    coreSkillDisplay: ['汽车驾驶','格斗','射击','两项社交技能（魅惑、话术、恐吓、说服）','心理学','潜行','侦查'],
    electiveDescription: '两项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 2,
  },
  {
    key: 'burglar',
    name: '窃贼',
    category: 'criminal',
    skillPointFormula: 'edu*2+dex*2',
    creditRatingMin: 5,
    creditRatingMax: 40,
    coreSkills: ['appraise','climb','elec_repair','mech_repair','listen','locksmith','sleight_of_hand','stealth','spot_hidden'],
    coreSkillDisplay: ['估价','攀爬','电气维修或机械维修','聆听','锁匠','妙手','潜行','侦查'],
    electiveDescription: '电气维修或机械维修',
    electiveCount: 1,
  },
  {
    key: 'con_man',
    name: '欺诈师',
    category: 'criminal',
    skillPointFormula: 'edu*2+app*2',
    creditRatingMin: 10,
    creditRatingMax: 65,
    coreSkills: ['appraise','art_craft:表演','law','language_other:任一','listen','charm','fast_talk','intimidate','persuade','psychology','sleight_of_hand'],
    coreSkillDisplay: ['估价','艺术（表演）','法律或外语','聆听','两项社交技能（魅惑、话术、恐吓、说服）','心理学','妙手'],
    electiveDescription: '两项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 2,
  },
  {
    key: 'lone_outlaw',
    name: '独行罪犯',
    category: 'criminal',
    skillPointFormula: 'edu*2+max(dex,app)*2',
    creditRatingMin: 5,
    creditRatingMax: 65,
    coreSkills: ['art_craft:表演','disguise','charm','fast_talk','intimidate','persuade','fighting:任一','firearms:任一','locksmith','mech_repair','stealth','psychology','spot_hidden'],
    coreSkillDisplay: ['艺术（表演）或乔装','一项社交技能（魅惑、话术、恐吓、说服）','格斗或射击','锁匠或机械维修','潜行','心理学','侦查'],
    electiveDescription: '艺术（表演）或乔装、格斗或射击、锁匠或机械维修',
    electiveCount: 3,
  },
  {
    key: 'cat_burglar',
    name: '女飞贼（古典）',
    category: 'criminal',
    skillPointFormula: 'edu*2+app*2',
    creditRatingMin: 10,
    creditRatingMax: 80,
    coreSkills: ['art_craft:任一','charm','fast_talk','intimidate','persuade','fighting:斗殴','firearms:手枪','drive_auto','listen','stealth'],
    coreSkillDisplay: ['艺术/工艺（任意）','两项社交技能（魅惑、话术、恐吓、说服）','格斗（斗殴）或射击（手枪）','汽车驾驶','聆听','潜行','任意一项其他个人或时代特长'],
    electiveDescription: '两项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 2,
  },
  {
    key: 'fence',
    name: '赃物贩子',
    category: 'criminal',
    skillPointFormula: 'edu*2+app*2',
    creditRatingMin: 20,
    creditRatingMax: 40,
    coreSkills: ['accounting','appraise','art_craft:伪造','history','charm','fast_talk','intimidate','persuade','library_use','spot_hidden'],
    coreSkillDisplay: ['会计','估价','工艺（伪造）','历史','一项社交技能（魅惑、话术、恐吓、说服）','图书馆使用','侦查','任意一项其他技能'],
    electiveDescription: '一项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 1,
  },
  {
    key: 'forger',
    name: '赝造者、伪造者',
    category: 'criminal',
    skillPointFormula: 'edu*4',
    creditRatingMin: 20,
    creditRatingMax: 60,
    coreSkills: ['accounting','appraise','art_craft:伪造','history','library_use','spot_hidden','sleight_of_hand'],
    coreSkillDisplay: ['会计','估价','工艺（伪造）','历史','图书馆使用','侦查','妙手','任意一项其他个人或时代特长（如计算机）'],
    electiveDescription: '任意一项其他个人或时代特长',
    electiveCount: 1,
  },
  {
    key: 'smuggler',
    name: '走私者',
    category: 'criminal',
    skillPointFormula: 'edu*2+max(app,dex)*2',
    creditRatingMin: 20,
    creditRatingMax: 60,
    coreSkills: ['firearms:任一','listen','navigate','charm','fast_talk','intimidate','persuade','drive_auto','psychology','sleight_of_hand','spot_hidden'],
    coreSkillDisplay: ['射击','聆听','导航','一项社交技能（魅惑、话术、恐吓、说服）','汽车驾驶或驾驶（飞行器或船）','心理学','妙手','侦查'],
    electiveDescription: '汽车驾驶或驾驶（飞行器或船）',
    electiveCount: 1,
  },
  {
    key: 'hooligan',
    name: '混混',
    category: 'criminal',
    skillPointFormula: 'edu*2+max(dex,str)*2',
    creditRatingMin: 3,
    creditRatingMax: 10,
    coreSkills: ['climb','charm','fast_talk','intimidate','persuade','fighting:任一','firearms:任一','jump','sleight_of_hand','stealth','throw'],
    coreSkillDisplay: ['攀爬','一项社交技能（魅惑、话术、恐吓、说服）','格斗','射击','跳跃','妙手','潜行','投掷'],
    electiveDescription: '一项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 1,
  },
  // 教团首领
  {
    key: 'cult_leader',
    name: '教团首领',
    category: 'general',
    skillPointFormula: 'edu*4',
    creditRatingMin: 30,
    creditRatingMax: 60,
    coreSkills: ['accounting','charm','fast_talk','intimidate','persuade','occult','psychology','spot_hidden'],
    coreSkillDisplay: ['会计','两项社交技能（魅惑、话术、恐吓、说服）','神秘学','心理学','侦查','任意其他两项其他个人特长'],
    electiveDescription: '两项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 2,
  },
  // 除魅师（现代）
  {
    key: 'deprogrammer',
    name: '除魅师（现代）',
    category: 'general',
    skillPointFormula: 'edu*4',
    creditRatingMin: 20,
    creditRatingMax: 50,
    coreSkills: ['charm','fast_talk','intimidate','persuade','drive_auto','fighting:斗殴','firearms:任一','history','occult','psychology','stealth'],
    coreSkillDisplay: ['两项社交技能（魅惑、话术、恐吓、说服）','汽车驾驶','格斗（斗殴）或射击','历史','神秘学','心理学','潜行'],
    electiveDescription: '两项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 2,
  },
  // 设计师
  {
    key: 'designer',
    name: '设计师',
    category: 'general',
    skillPointFormula: 'edu*4',
    creditRatingMin: 20,
    creditRatingMax: 60,
    coreSkills: ['accounting','art_craft:摄影','art_craft:任一','computer_use','library_use','mech_repair','psychology','spot_hidden'],
    coreSkillDisplay: ['会计','艺术（摄影）','艺术/工艺（任一）','计算机使用或图书馆使用','机械维修','心理学','侦查','任意一项其他个人特长'],
    electiveDescription: '计算机使用或图书馆使用',
    electiveCount: 1,
  },
  // 潜水员
  {
    key: 'diver',
    name: '潜水员',
    category: 'outdoor',
    skillPointFormula: 'edu*2+dex*2',
    creditRatingMin: 9,
    creditRatingMax: 30,
    coreSkills: ['diving','first_aid','mech_repair','pilot:船','science:生物学','spot_hidden','swim'],
    coreSkillDisplay: ['潜水','急救','机械维修','驾驶（船）','科学（生物）','侦查','游泳','任意一项其他个人或时代特长'],
    electiveDescription: '任意一项其他个人或时代特长',
    electiveCount: 1,
  },
  // 医生（原作向）
  {
    key: 'doctor',
    name: '医生（原作向）',
    category: 'medical',
    skillPointFormula: 'edu*4',
    creditRatingMin: 30,
    creditRatingMax: 80,
    coreSkills: ['first_aid','medicine','language_other:拉丁文','psychology','science:生物学','science:药学'],
    coreSkillDisplay: ['急救','医学','外语（拉丁文）','心理学','科学（生物学，药学）','任两种其他学术或个人特长'],
    electiveDescription: '任两种其他学术或个人特长',
    electiveCount: 2,
  },
  // 流浪者
  {
    key: 'drifter',
    name: '流浪者',
    category: 'general',
    skillPointFormula: 'edu*2+max(app,dex,str)*2',
    creditRatingMin: 0,
    creditRatingMax: 5,
    coreSkills: ['climb','jump','listen','navigate','charm','fast_talk','intimidate','persuade','stealth'],
    coreSkillDisplay: ['攀爬','跳跃','聆听','导航','一项社交技能（魅惑、话术、恐吓、说服）','潜行','任意两项其他个人或时代特长'],
    electiveDescription: '一项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 1,
  },
  // 司机-私人司机
  {
    key: 'chauffeur',
    name: '私人司机',
    category: 'service',
    skillPointFormula: 'edu*2+dex*2',
    creditRatingMin: 10,
    creditRatingMax: 40,
    coreSkills: ['drive_auto','charm','fast_talk','intimidate','persuade','listen','mech_repair','navigate','spot_hidden'],
    coreSkillDisplay: ['汽车驾驶','两项社交技能（魅惑、话术、恐吓、说服）','聆听','机械维修','导航','侦查','任意一项其他个人或时代特长'],
    electiveDescription: '两项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 2,
  },
  // 司机
  {
    key: 'driver',
    name: '司机',
    category: 'service',
    skillPointFormula: 'edu*2+max(dex,str)*2',
    creditRatingMin: 9,
    creditRatingMax: 20,
    coreSkills: ['accounting','drive_auto','listen','charm','fast_talk','intimidate','persuade','mech_repair','navigate','psychology'],
    coreSkillDisplay: ['会计','汽车驾驶','聆听','一项社交技能（魅惑、话术、恐吓、说服）','机械维修','导航','心理学','任意一项其他个人或时代特长'],
    electiveDescription: '一项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 1,
  },
  // 出租车司机
  {
    key: 'taxi_driver',
    name: '出租车司机',
    category: 'service',
    skillPointFormula: 'edu*2+dex*2',
    creditRatingMin: 9,
    creditRatingMax: 30,
    coreSkills: ['accounting','drive_auto','elec_repair','fast_talk','mech_repair','navigate','spot_hidden'],
    coreSkillDisplay: ['会计','汽车驾驶','电气维修','话术','机械维修','导航','侦查','任意一项其他个人或时代特长'],
    electiveDescription: '任意一项其他个人或时代特长',
    electiveCount: 1,
  },
  // 编辑
  {
    key: 'editor',
    name: '编辑',
    category: 'media',
    skillPointFormula: 'edu*4',
    creditRatingMin: 10,
    creditRatingMax: 30,
    coreSkills: ['accounting','history','language_own','charm','fast_talk','intimidate','persuade','psychology','spot_hidden'],
    coreSkillDisplay: ['会计','历史','母语','两项社交技能（魅惑、话术、恐吓、说服）','心理学','侦查','任意一项其他个人或时代特长'],
    electiveDescription: '两项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 2,
  },
  // 政府官员
  {
    key: 'official',
    name: '政府官员',
    category: 'general',
    skillPointFormula: 'edu*2+app*2',
    creditRatingMin: 50,
    creditRatingMax: 90,
    coreSkills: ['charm','history','intimidate','fast_talk','listen','language_own','persuade','psychology'],
    coreSkillDisplay: ['魅惑','历史','恐吓','话术','聆听','母语','说服','心理学'],
    electiveCount: 0,
  },
  // 工程师
  {
    key: 'engineer',
    name: '工程师',
    category: 'academic',
    skillPointFormula: 'edu*4',
    creditRatingMin: 30,
    creditRatingMax: 60,
    coreSkills: ['art_craft:技术制图','elec_repair','library_use','mech_repair','heavy_machinery','science:工程学','science:物理学'],
    coreSkillDisplay: ['工艺（技术制图）','电气维修','图书馆使用','机械维修','操作重型机械','科学（工程学，物理）','任意一项其他个人或时代特长'],
    electiveDescription: '任意一项其他个人或时代特长',
    electiveCount: 1,
  },
  // 探险家（古典）
  {
    key: 'explorer',
    name: '探险家（古典）',
    category: 'outdoor',
    skillPointFormula: 'edu*2+max(app,dex,str)*2',
    creditRatingMin: 55,
    creditRatingMax: 80,
    coreSkills: ['climb','swim','firearms:任一','history','jump','natural_world','navigate','language_other:任一','survival:任一'],
    coreSkillDisplay: ['攀爬或游泳','射击','历史','跳跃','博物学','导航','外语','生存'],
    electiveDescription: '攀爬或游泳',
    electiveCount: 1,
  },
  // 艺人
  {
    key: 'entertainer',
    name: '艺人',
    category: 'artistic',
    skillPointFormula: 'edu*2+app*2',
    creditRatingMin: 9,
    creditRatingMax: 70,
    coreSkills: ['art_craft:表演','disguise','charm','fast_talk','intimidate','persuade','listen','psychology'],
    coreSkillDisplay: ['艺术（表演类，如表演、声乐、喜剧等）','乔装','两项社交技能（魅惑、话术、恐吓、说服）','聆听','心理学','任意两项其他个人或时代特长'],
    electiveDescription: '两项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 2,
  },
  // 农民
  {
    key: 'farmer',
    name: '农民',
    category: 'outdoor',
    skillPointFormula: 'edu*2+max(dex,str)*2',
    creditRatingMin: 9,
    creditRatingMax: 30,
    coreSkills: ['art_craft:耕作','drive_auto','charm','fast_talk','intimidate','persuade','mech_repair','natural_world','heavy_machinery','track'],
    coreSkillDisplay: ['工艺（耕作）','汽车驾驶（或运货马车）','一项社交技能（魅惑、话术、恐吓、说服）','机械维修','博物学','操作重型机械','追踪','任意一项其他个人或时代特长'],
    electiveDescription: '汽车驾驶或运货马车',
    electiveCount: 1,
  },
  // 联邦探员
  {
    key: 'federal_agent',
    name: '联邦探员',
    category: 'military',
    skillPointFormula: 'edu*4',
    creditRatingMin: 20,
    creditRatingMax: 40,
    coreSkills: ['drive_auto','fighting:斗殴','firearms:任一','law','persuade','stealth','spot_hidden'],
    coreSkillDisplay: ['汽车驾驶','格斗（斗殴）','射击','法律','说服','潜行','侦查','任意一项其他个人或时代特长'],
    electiveDescription: '任意一项其他个人或时代特长',
    electiveCount: 1,
  },
  // 消防员
  {
    key: 'firefighter',
    name: '消防员',
    category: 'military',
    skillPointFormula: 'edu*2+max(dex,str)*2',
    creditRatingMin: 9,
    creditRatingMax: 30,
    coreSkills: ['climb','dodge','drive_auto','first_aid','jump','mech_repair','heavy_machinery','throw'],
    coreSkillDisplay: ['攀爬','闪避','汽车驾驶','急救','跳跃','机械维修','操作重型机械','投掷'],
    electiveCount: 0,
  },
  // 驻外记者
  {
    key: 'foreign_correspondent',
    name: '驻外记者',
    category: 'media',
    skillPointFormula: 'edu*4',
    creditRatingMin: 10,
    creditRatingMax: 40,
    coreSkills: ['history','language_other:任一','language_own','listen','charm','fast_talk','intimidate','persuade','psychology'],
    coreSkillDisplay: ['历史','外语','母语','聆听','两项社交技能（魅惑、话术、恐吓、说服）','心理学','任意一项其他个人或时代特长'],
    electiveDescription: '两项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 2,
  },
  // 法医
  {
    key: 'forensic_pathologist',
    name: '法医',
    category: 'medical',
    skillPointFormula: 'edu*4',
    creditRatingMin: 40,
    creditRatingMax: 60,
    coreSkills: ['language_other:拉丁文','library_use','medicine','persuade','science:生物学','science:司法科学','science:药学','spot_hidden'],
    coreSkillDisplay: ['外语（拉丁文）','图书馆使用','医学','说服','科学（生物学，司法科学，药学）','侦查'],
    electiveCount: 0,
  },
  // 赌徒
  {
    key: 'gambler',
    name: '赌徒',
    category: 'criminal',
    skillPointFormula: 'edu*2+max(app,dex)*2',
    creditRatingMin: 8,
    creditRatingMax: 50,
    coreSkills: ['accounting','art_craft:表演','charm','fast_talk','intimidate','persuade','listen','psychology','sleight_of_hand','spot_hidden'],
    coreSkillDisplay: ['会计','艺术（表演）','两项社交技能（魅惑、话术、恐吓、说服）','聆听','心理学','妙手','侦查'],
    electiveDescription: '两项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 2,
  },
  // 黑帮老大
  {
    key: 'gang_boss',
    name: '黑帮老大',
    category: 'criminal',
    skillPointFormula: 'edu*2+app*2',
    creditRatingMin: 60,
    creditRatingMax: 95,
    coreSkills: ['fighting:任一','firearms:任一','law','listen','charm','fast_talk','intimidate','persuade','psychology','spot_hidden'],
    coreSkillDisplay: ['格斗','射击','法律','聆听','两项社交技能（魅惑、话术、恐吓、说服）','心理学','侦查'],
    electiveDescription: '两项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 2,
  },
  // 黑帮马仔
  {
    key: 'gang_underling',
    name: '黑帮马仔',
    category: 'criminal',
    skillPointFormula: 'edu*2+max(dex,str)*2',
    creditRatingMin: 9,
    creditRatingMax: 20,
    coreSkills: ['drive_auto','fighting:任一','firearms:任一','charm','fast_talk','intimidate','persuade','psychology'],
    coreSkillDisplay: ['汽车驾驶','格斗','射击','两项社交技能（魅惑、话术、恐吓、说服）','心理学','任意两项其他个人或时代特长'],
    electiveDescription: '两项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 2,
  },
  // 绅士、淑女
  {
    key: 'gentleman_lady',
    name: '绅士、淑女',
    category: 'general',
    skillPointFormula: 'edu*2+app*2',
    creditRatingMin: 40,
    creditRatingMax: 90,
    coreSkills: ['art_craft:任一','charm','fast_talk','intimidate','persuade','firearms:步枪/霰弹枪','history','language_other:任一','navigate','ride'],
    coreSkillDisplay: ['艺术/工艺（任一）','两项社交技能（魅惑、话术、恐吓、说服）','射击（步枪/霰弹枪）','历史','外语','导航','骑术'],
    electiveDescription: '两项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 2,
  },
  // 游民
  {
    key: 'hobo',
    name: '游民',
    category: 'general',
    skillPointFormula: 'edu*2+max(app,dex)*2',
    creditRatingMin: 0,
    creditRatingMax: 5,
    coreSkills: ['art_craft:任一','climb','jump','listen','locksmith','sleight_of_hand','navigate','stealth'],
    coreSkillDisplay: ['艺术/工艺（任一）','攀爬','跳跃','聆听','锁匠或妙手','导航','潜行','任意一项其他个人或时代特长'],
    electiveDescription: '锁匠或妙手',
    electiveCount: 1,
  },
  // 调查记者
  {
    key: 'investigative_reporter',
    name: '调查记者',
    category: 'media',
    skillPointFormula: 'edu*4',
    creditRatingMin: 9,
    creditRatingMax: 30,
    coreSkills: ['art_craft:摄影','charm','fast_talk','intimidate','persuade','history','library_use','language_own','psychology'],
    coreSkillDisplay: ['艺术/工艺（艺术或摄影）','一项社交技能（魅惑、话术、恐吓、说服）','历史','图书馆使用','母语','心理学','任意两项其他个人或时代特长'],
    electiveDescription: '一项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 1,
  },
  // 通讯记者
  {
    key: 'correspondent',
    name: '通讯记者',
    category: 'media',
    skillPointFormula: 'edu*4',
    creditRatingMin: 9,
    creditRatingMax: 30,
    coreSkills: ['art_craft:表演','history','listen','language_own','charm','fast_talk','intimidate','persuade','psychology','stealth','spot_hidden'],
    coreSkillDisplay: ['艺术（表演）','历史','聆听','母语','一项社交技能（魅惑、话术、恐吓、说服）','心理学','潜行','侦查'],
    electiveDescription: '一项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 1,
  },
  // 法官
  {
    key: 'judge',
    name: '法官',
    category: 'general',
    skillPointFormula: 'edu*4',
    creditRatingMin: 50,
    creditRatingMax: 80,
    coreSkills: ['history','intimidate','law','library_use','listen','language_own','persuade','psychology'],
    coreSkillDisplay: ['历史','恐吓','法律','图书馆使用','聆听','母语','说服','心理学'],
    electiveCount: 0,
  },
  // 实验室助理
  {
    key: 'lab_assistant',
    name: '实验室助理',
    category: 'academic',
    skillPointFormula: 'edu*4',
    creditRatingMin: 10,
    creditRatingMax: 30,
    coreSkills: ['computer_use','library_use','elec_repair','language_other:任一','science:化学','spot_hidden'],
    coreSkillDisplay: ['计算机使用或图书馆使用','电气维修','外语','科学（化学和任意两项）','侦查','任意一项其他个人特长'],
    electiveDescription: '计算机使用或图书馆使用',
    electiveCount: 1,
  },
  // 非熟练工人
  {
    key: 'laborer',
    name: '非熟练工人',
    category: 'general',
    skillPointFormula: 'edu*2+max(dex,str)*2',
    creditRatingMin: 9,
    creditRatingMax: 30,
    coreSkills: ['drive_auto','elec_repair','fighting:斗殴','first_aid','mech_repair','heavy_machinery','throw'],
    coreSkillDisplay: ['汽车驾驶','电气维修','格斗','急救','机械维修','操作重型机械','投掷','任意一项其他个人或时代特长'],
    electiveDescription: '任意一项其他个人或时代特长',
    electiveCount: 1,
  },
  // 伐木工
  {
    key: 'logger',
    name: '伐木工',
    category: 'outdoor',
    skillPointFormula: 'edu*2+max(dex,str)*2',
    creditRatingMin: 9,
    creditRatingMax: 30,
    coreSkills: ['climb','dodge','fighting:链锯','first_aid','jump','mech_repair','natural_world','science:生物学','throw'],
    coreSkillDisplay: ['攀爬','闪避','格斗（链锯）','急救','跳跃','机械维修','博物学或科学（生物学或植物学）','投掷'],
    electiveDescription: '博物学或科学（生物学或植物学）',
    electiveCount: 1,
  },
  // 矿工
  {
    key: 'miner',
    name: '矿工',
    category: 'general',
    skillPointFormula: 'edu*2+max(dex,str)*2',
    creditRatingMin: 9,
    creditRatingMax: 30,
    coreSkills: ['climb','science:地质学','jump','mech_repair','heavy_machinery','stealth','spot_hidden'],
    coreSkillDisplay: ['攀爬','科学（地质学）','跳跃','机械维修','操作重型机械','潜行','侦查','任意一项其他个人或时代特长'],
    electiveDescription: '任意一项其他个人或时代特长',
    electiveCount: 1,
  },
  // 律师
  {
    key: 'lawyer',
    name: '律师',
    category: 'general',
    skillPointFormula: 'edu*4',
    creditRatingMin: 30,
    creditRatingMax: 80,
    coreSkills: ['accounting','law','library_use','charm','fast_talk','intimidate','persuade','psychology'],
    coreSkillDisplay: ['会计','法律','图书馆使用','两项社交技能（魅惑、话术、恐吓、说服）','心理学','两项其他技能'],
    electiveDescription: '两项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 2,
  },
  // 图书馆管理员
  {
    key: 'librarian',
    name: '图书馆管理员',
    category: 'academic',
    skillPointFormula: 'edu*4',
    creditRatingMin: 9,
    creditRatingMax: 35,
    coreSkills: ['accounting','library_use','language_other:任一','language_own'],
    coreSkillDisplay: ['会计','图书馆使用','外语','母语','任意四项其他个人特长或专业书籍主题'],
    electiveDescription: '任意四项其他个人特长或专业书籍主题',
    electiveCount: 4,
  },
  // 技师
  {
    key: 'mechanic',
    name: '技师',
    category: 'general',
    skillPointFormula: 'edu*4',
    creditRatingMin: 9,
    creditRatingMax: 40,
    coreSkills: ['art_craft:木工焊接管道工等','climb','drive_auto','elec_repair','mech_repair','heavy_machinery'],
    coreSkillDisplay: ['工艺（木工、焊接、管道工等）','攀爬','汽车驾驶','电气维修','机械维修','操作重型机械','任意两项其他个人或时代或技术特长'],
    electiveDescription: '任意两项其他个人或时代或技术特长',
    electiveCount: 2,
  },
  // 军官
  {
    key: 'military_officer',
    name: '军官',
    category: 'military',
    skillPointFormula: 'edu*2+max(dex,str)*2',
    creditRatingMin: 20,
    creditRatingMax: 70,
    coreSkills: ['accounting','firearms:任一','navigate','first_aid','charm','fast_talk','intimidate','persuade','psychology'],
    coreSkillDisplay: ['会计','射击','导航','急救','两项社交技能（魅惑、话术、恐吓、说服）','心理学','任意一项其他个人或时代特长'],
    electiveDescription: '两项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 2,
  },
  // 传教士
  {
    key: 'missionary',
    name: '传教士',
    category: 'general',
    skillPointFormula: 'edu*4',
    creditRatingMin: 0,
    creditRatingMax: 30,
    coreSkills: ['art_craft:任一','first_aid','mech_repair','medicine','natural_world','charm','fast_talk','intimidate','persuade'],
    coreSkillDisplay: ['艺术/工艺（任一）','急救','机械维修','医学','博物学','一项社交技能（魅惑、话术、恐吓、说服）','任意两项其他个人或时代特长'],
    electiveDescription: '一项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 1,
  },
  // 登山家
  {
    key: 'mountaineer',
    name: '登山家',
    category: 'outdoor',
    skillPointFormula: 'edu*2+max(dex,str)*2',
    creditRatingMin: 30,
    creditRatingMax: 60,
    coreSkills: ['climb','first_aid','jump','listen','navigate','language_other:任一','survival:阿尔卑斯或类似','track'],
    coreSkillDisplay: ['攀爬','急救','跳跃','聆听','导航','外语','生存（阿尔卑斯或类似）','追踪'],
    electiveCount: 0,
  },
  // 博物馆管理员
  {
    key: 'museum_curator',
    name: '博物馆管理员',
    category: 'academic',
    skillPointFormula: 'edu*4',
    creditRatingMin: 10,
    creditRatingMax: 30,
    coreSkills: ['accounting','appraise','archaeology','history','library_use','occult','language_other:任一','spot_hidden'],
    coreSkillDisplay: ['会计','估价','考古学','历史','图书馆使用','神秘学','外语','侦查'],
    electiveCount: 0,
  },
  // 音乐家
  {
    key: 'musician',
    name: '音乐家',
    category: 'artistic',
    skillPointFormula: 'edu*2+max(pow,dex)*2',
    creditRatingMin: 9,
    creditRatingMax: 30,
    coreSkills: ['art_craft:器乐','charm','fast_talk','intimidate','persuade','listen','psychology'],
    coreSkillDisplay: ['艺术（器乐）','一项社交技能（魅惑、话术、恐吓、说服）','聆听','心理学','四项其他技能'],
    electiveDescription: '四项其他技能',
    electiveCount: 4,
  },
  // 护士
  {
    key: 'nurse',
    name: '护士',
    category: 'medical',
    skillPointFormula: 'edu*4',
    creditRatingMin: 9,
    creditRatingMax: 30,
    coreSkills: ['first_aid','listen','medicine','charm','fast_talk','intimidate','persuade','psychology','science:生物学','science:化学','spot_hidden'],
    coreSkillDisplay: ['急救','聆听','医学','一项社交技能（魅惑、话术、恐吓、说服）','心理学','科学（生物学，化学）','侦查'],
    electiveDescription: '一项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 1,
  },
  // 神秘学家
  {
    key: 'occultist',
    name: '神秘学家',
    category: 'academic',
    skillPointFormula: 'edu*4',
    creditRatingMin: 9,
    creditRatingMax: 65,
    coreSkills: ['anthropology','history','library_use','charm','fast_talk','intimidate','persuade','occult','language_other:任一','science:天文学'],
    coreSkillDisplay: ['人类学','历史','图书馆使用','一项社交技能（魅惑、话术、恐吓、说服）','神秘学','外语','科学（天文）','任意一项其他个人或时代特长'],
    electiveDescription: '一项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 1,
  },
  // 超心理学家
  {
    key: 'parapsychologist',
    name: '超心理学家',
    category: 'academic',
    skillPointFormula: 'edu*4',
    creditRatingMin: 9,
    creditRatingMax: 30,
    coreSkills: ['anthropology','art_craft:摄影','history','library_use','occult','language_other:任一','psychology'],
    coreSkillDisplay: ['人类学','艺术（摄影）','历史','图书馆使用','神秘学','外语','心理学','任意一项其他个人或时代特长'],
    electiveDescription: '任意一项其他个人或时代特长',
    electiveCount: 1,
  },
  // 药剂师
  {
    key: 'pharmacist',
    name: '药剂师',
    category: 'medical',
    skillPointFormula: 'edu*4',
    creditRatingMin: 35,
    creditRatingMax: 75,
    coreSkills: ['accounting','first_aid','language_other:拉丁文','library_use','charm','fast_talk','intimidate','persuade','psychology','science:药学','science:化学'],
    coreSkillDisplay: ['会计','急救','外语（拉丁文）','图书馆使用','一项社交技能（魅惑、话术、恐吓、说服）','心理学','科学（药学，化学）'],
    electiveDescription: '一项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 1,
  },
  // 飞行员
  {
    key: 'pilot',
    name: '飞行员',
    category: 'general',
    skillPointFormula: 'edu*2+dex*2',
    creditRatingMin: 20,
    creditRatingMax: 70,
    coreSkills: ['elec_repair','mech_repair','navigate','heavy_machinery','pilot:飞机','science:天文学'],
    coreSkillDisplay: ['电气维修','机械维修','导航','操作重型机械','驾驶（飞行器）','科学（天文）','任意两项其他个人或时代特长'],
    electiveDescription: '任意两项其他个人或时代特长',
    electiveCount: 2,
  },
  // 特技飞行员
  {
    key: 'stunt_pilot',
    name: '特技飞行员（古典）',
    category: 'general',
    skillPointFormula: 'edu*4',
    creditRatingMin: 30,
    creditRatingMax: 60,
    coreSkills: ['accounting','elec_repair','listen','mech_repair','navigate','pilot:飞机','spot_hidden'],
    coreSkillDisplay: ['会计','电气维修','聆听','机械维修','导航','驾驶（飞行器）','侦查','任意一项其他个人或时代特长'],
    electiveDescription: '任意一项其他个人或时代特长',
    electiveCount: 1,
  },
  // 摄影师
  {
    key: 'photographer',
    name: '摄影师',
    category: 'artistic',
    skillPointFormula: 'edu*4',
    creditRatingMin: 9,
    creditRatingMax: 30,
    coreSkills: ['art_craft:摄影','charm','fast_talk','intimidate','persuade','psychology','science:化学','stealth','spot_hidden'],
    coreSkillDisplay: ['艺术（摄影）','一项社交技能（魅惑、话术、恐吓、说服）','心理学','科学（化学）','潜行','侦查','任意两项其他个人或时代特长'],
    electiveDescription: '一项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 1,
  },
  // 摄影记者
  {
    key: 'photojournalist',
    name: '摄影记者',
    category: 'media',
    skillPointFormula: 'edu*4',
    creditRatingMin: 10,
    creditRatingMax: 30,
    coreSkills: ['art_craft:摄影','climb','charm','fast_talk','intimidate','persuade','language_other:任一','psychology','spot_hidden'],
    coreSkillDisplay: ['艺术（摄影）','攀爬','一项社交技能（魅惑、话术、恐吓、说服）','外语','心理学','侦查','一项其他个人或时代特长（如计算机、锁匠、格斗、射击）'],
    electiveDescription: '一项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 1,
  },
  // 警探
  {
    key: 'police_detective',
    name: '警探',
    category: 'military',
    skillPointFormula: 'edu*2+max(dex,str)*2',
    creditRatingMin: 20,
    creditRatingMax: 50,
    coreSkills: ['art_craft:表演','disguise','firearms:任一','law','listen','charm','fast_talk','intimidate','persuade','psychology','spot_hidden'],
    coreSkillDisplay: ['艺术（表演）或乔装','射击','法律','聆听','一项社交技能（魅惑、话术、恐吓、说服）','心理学','侦查','一项其他技能'],
    electiveDescription: '艺术（表演）或乔装、一项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 2,
  },
  // 警官
  {
    key: 'police_officer',
    name: '警官',
    category: 'military',
    skillPointFormula: 'edu*2+max(dex,str)*2',
    creditRatingMin: 9,
    creditRatingMax: 30,
    coreSkills: ['fighting:斗殴','firearms:任一','first_aid','charm','fast_talk','intimidate','persuade','law','psychology','spot_hidden','drive_auto','ride'],
    coreSkillDisplay: ['格斗（斗殴）','射击','急救','一项社交技能（魅惑、话术、恐吓、说服）','法律','心理学','侦查','汽车驾驶或骑术'],
    electiveDescription: '汽车驾驶或骑术',
    electiveCount: 1,
  },
  // 私家侦探
  {
    key: 'private_investigator',
    name: '私家侦探',
    category: 'general',
    skillPointFormula: 'edu*2+max(dex,str)*2',
    creditRatingMin: 9,
    creditRatingMax: 30,
    coreSkills: ['art_craft:摄影','disguise','law','library_use','charm','fast_talk','intimidate','persuade','psychology','spot_hidden'],
    coreSkillDisplay: ['艺术（摄影）','乔装','法律','图书馆使用','一项社交技能（魅惑、话术、恐吓、说服）','心理学','侦查','一项其他个人或时代特长（如计算机、锁匠、格斗、射击）'],
    electiveDescription: '一项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 1,
  },
  // 教授
  {
    key: 'professor',
    name: '教授',
    category: 'academic',
    skillPointFormula: 'edu*4',
    creditRatingMin: 20,
    creditRatingMax: 70,
    coreSkills: ['library_use','language_other:任一','language_own','psychology'],
    coreSkillDisplay: ['图书馆使用','外语','母语','心理学','任意四项其他学术、时代或个人特长'],
    electiveDescription: '任意四项其他学术、时代或个人特长',
    electiveCount: 4,
  },
  // 淘金客
  {
    key: 'prospector',
    name: '淘金客',
    category: 'outdoor',
    skillPointFormula: 'edu*2+max(dex,str)*2',
    creditRatingMin: 0,
    creditRatingMax: 10,
    coreSkills: ['climb','first_aid','history','mech_repair','navigate','science:地质学','spot_hidden'],
    coreSkillDisplay: ['攀爬','急救','历史','机械维修','导航','科学（地质学）','侦查','任意一项其他个人或时代特长'],
    electiveDescription: '任意一项其他个人或时代特长',
    electiveCount: 1,
  },
  // 性工作者
  {
    key: 'prostitute',
    name: '性工作者',
    category: 'general',
    skillPointFormula: 'edu*2+app*2',
    creditRatingMin: 5,
    creditRatingMax: 50,
    coreSkills: ['art_craft:任一','charm','fast_talk','intimidate','persuade','dodge','psychology','sleight_of_hand','stealth'],
    coreSkillDisplay: ['艺术/工艺（任一）','两项社交技能（魅惑、话术、恐吓、说服）','闪避','心理学','妙手','潜行','任意一项其他个人或时代特长'],
    electiveDescription: '两项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 2,
  },
  // 精神病学家
  {
    key: 'psychiatrist',
    name: '精神病学家',
    category: 'medical',
    skillPointFormula: 'edu*4',
    creditRatingMin: 30,
    creditRatingMax: 80,
    coreSkills: ['language_other:任一','listen','medicine','persuade','psychoanalysis','psychology','science:生物学','science:化学'],
    coreSkillDisplay: ['外语','聆听','医学','说服','精神分析','心理学','科学（生物学，化学）'],
    electiveCount: 0,
  },
  // 心理学家
  {
    key: 'psychologist',
    name: '心理学家',
    category: 'academic',
    skillPointFormula: 'edu*4',
    creditRatingMin: 10,
    creditRatingMax: 40,
    coreSkills: ['accounting','library_use','listen','persuade','psychoanalysis','psychology'],
    coreSkillDisplay: ['会计','图书馆使用','聆听','说服','精神分析','心理学','任意两项其他学术、个人或时代特长'],
    electiveDescription: '任意两项其他学术、个人或时代特长',
    electiveCount: 2,
  },
  // 研究员
  {
    key: 'researcher',
    name: '研究员',
    category: 'academic',
    skillPointFormula: 'edu*4',
    creditRatingMin: 9,
    creditRatingMax: 30,
    coreSkills: ['history','library_use','charm','fast_talk','intimidate','persuade','language_other:任一','spot_hidden'],
    coreSkillDisplay: ['历史','图书馆使用','一项社交技能（魅惑、话术、恐吓、说服）','外语','侦查','任意三项其他学术领域'],
    electiveDescription: '一项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 1,
  },
  // 海员-军舰
  {
    key: 'sailor_military',
    name: '海员（军舰）',
    category: 'military',
    skillPointFormula: 'edu*2+max(dex,str)*2',
    creditRatingMin: 9,
    creditRatingMax: 30,
    coreSkills: ['elec_repair','mech_repair','fighting:斗殴','firearms:任一','first_aid','navigate','pilot:船','survival:海洋','swim'],
    coreSkillDisplay: ['电工或机械维修','格斗','射击','急救','导航','驾驶（船）','生存（海上）','游泳'],
    electiveDescription: '电工或机械维修',
    electiveCount: 1,
  },
  // 海员-民用船
  {
    key: 'sailor_civilian',
    name: '海员（民用船）',
    category: 'general',
    skillPointFormula: 'edu*2+max(dex,str)*2',
    creditRatingMin: 20,
    creditRatingMax: 40,
    coreSkills: ['first_aid','mech_repair','natural_world','navigate','charm','fast_talk','intimidate','persuade','pilot:船','spot_hidden','swim'],
    coreSkillDisplay: ['急救','机械维修','博物学','导航','一项社交技能（魅惑、话术、恐吓、说服）','驾驶（船）','侦查','游泳'],
    electiveDescription: '一项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 1,
  },
  // 推销员
  {
    key: 'salesman',
    name: '推销员',
    category: 'general',
    skillPointFormula: 'edu*2+app*2',
    creditRatingMin: 9,
    creditRatingMax: 40,
    coreSkills: ['accounting','charm','fast_talk','intimidate','persuade','drive_auto','listen','psychology','stealth','sleight_of_hand'],
    coreSkillDisplay: ['会计','两项社交技能（魅惑、话术、恐吓、说服）','汽车驾驶','聆听','心理学','潜行或妙手','一项其他技能'],
    electiveDescription: '两项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 2,
  },
  // 科学家
  {
    key: 'scientist',
    name: '科学家',
    category: 'academic',
    skillPointFormula: 'edu*4',
    creditRatingMin: 9,
    creditRatingMax: 50,
    coreSkills: ['computer_use','library_use','language_other:任一','language_own','charm','fast_talk','intimidate','persuade','spot_hidden'],
    coreSkillDisplay: ['任意三项科学专业领域','计算机使用或图书馆使用','外语','母语','一项社交技能（魅惑、话术、恐吓、说服）','侦查'],
    electiveDescription: '任意三项科学专业领域',
    electiveCount: 3,
  },
  // 秘书
  {
    key: 'secretary',
    name: '秘书',
    category: 'service',
    skillPointFormula: 'edu*2+max(dex,app)*2',
    creditRatingMin: 9,
    creditRatingMax: 30,
    coreSkills: ['accounting','art_craft:打字或速记','charm','fast_talk','intimidate','persuade','language_own','library_use','computer_use','psychology'],
    coreSkillDisplay: ['会计','工艺（打字或速记）','两项社交技能（魅惑、话术、恐吓、说服）','母语','图书馆使用或计算机使用','心理学','任意一项其他个人或时代特长'],
    electiveDescription: '两项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 2,
  },
  // 店老板
  {
    key: 'shopkeeper',
    name: '店老板',
    category: 'general',
    skillPointFormula: 'edu*2+max(app,dex)*2',
    creditRatingMin: 20,
    creditRatingMax: 40,
    coreSkills: ['accounting','charm','fast_talk','intimidate','persuade','elec_repair','listen','mech_repair','psychology','spot_hidden'],
    coreSkillDisplay: ['会计','两项社交技能（魅惑、话术、恐吓、说服）','电气维修','聆听','机械维修','心理学','侦查'],
    electiveDescription: '两项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 2,
  },
  // 士兵
  {
    key: 'soldier',
    name: '士兵、海军陆战队士兵',
    category: 'military',
    skillPointFormula: 'edu*2+max(dex,str)*2',
    creditRatingMin: 9,
    creditRatingMax: 30,
    coreSkills: ['climb','swim','dodge','fighting:任一','firearms:任一','stealth','survival:任一'],
    coreSkillDisplay: ['攀爬或游泳','闪避','格斗','射击','潜行','生存','下面任选两项：急救、机械维修、外语'],
    electiveDescription: '下面任选两项：急救、机械维修、外语',
    electiveCount: 2,
  },
  // 间谍
  {
    key: 'spy',
    name: '间谍',
    category: 'criminal',
    skillPointFormula: 'edu*2+max(app,dex)*2',
    creditRatingMin: 20,
    creditRatingMax: 60,
    coreSkills: ['art_craft:表演','disguise','firearms:任一','listen','language_other:任一','charm','fast_talk','intimidate','persuade','psychology','sleight_of_hand','stealth'],
    coreSkillDisplay: ['艺术（表演）或乔装','射击','聆听','外语','一项社交技能（魅惑、话术、恐吓、说服）','心理学','妙手','潜行'],
    electiveDescription: '艺术（表演）或乔装、一项社交技能（魅惑、话术、恐吓、说服）',
    electiveCount: 2,
  },
  // 部落成员
  {
    key: 'tribesman',
    name: '部落成员',
    category: 'outdoor',
    skillPointFormula: 'edu*2+max(dex,str)*2',
    creditRatingMin: 0,
    creditRatingMax: 15,
    coreSkills: ['climb','fighting:任一','throw','listen','natural_world','occult','spot_hidden','swim','survival:任一'],
    coreSkillDisplay: ['攀爬','格斗或投掷','聆听','博物学','神秘学','侦查','游泳','生存（任一）'],
    electiveCount: 0,
  },
  // 学生
  {
    key: 'student',
    name: '学生、实习生',
    category: 'academic',
    skillPointFormula: 'edu*4',
    creditRatingMin: 5,
    creditRatingMax: 10,
    coreSkills: ['language_own','language_other:任一','library_use','listen'],
    coreSkillDisplay: ['语言（母语或外语）','图书馆使用','聆听','三个和学习内容相关的专业技能','任意两项其他个人或时代特长'],
    electiveDescription: '三个和学习内容相关的专业技能',
    electiveCount: 3,
  },
  // 替身演员
  {
    key: 'stuntman',
    name: '替身演员',
    category: 'artistic',
    skillPointFormula: 'edu*2+max(dex,str)*2',
    creditRatingMin: 10,
    creditRatingMax: 50,
    coreSkills: ['climb','dodge','elec_repair','mech_repair','fighting:任一','first_aid','jump','swim'],
    coreSkillDisplay: ['攀爬','闪避','电气维修或机械维修','格斗','急救','跳跃','游泳','下面任选一项：潜水、汽车驾驶、驾驶（任一）、骑术'],
    electiveDescription: '电气维修或机械维修',
    electiveCount: 1,
  },
];

// 通过 key 查找职业信息
export function getOccupationInfo(key: string): OccupationDisplay | undefined {
  return COC7E_OCCUPATIONS.find(o => o.key === key);
}
